export default __webpack_public_path__ + "static/media/houseclerk_paulnardo.489d8f4a.png";